import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OwlCarousel from 'react-owl-carousel';
import { HashLink as Link } from 'react-router-hash-link';
import SvgCircle from '../components/svgCircle';

const Blog = () => {

   const [updater, setUpdater] = useState(1);

   const { t, i18n } = useTranslation()

   i18n.on('languageChanged', () => {
      setTimeout(() => setUpdater(updater + 1), 100)
   })

   // OwlCarousel Option for Blogs
   const options = {
      0: {
         items: 1,
         dots: true,
         margin: 5,
      },
      600: {
         items: 1,
         dots: true,
         margin: 0,
      },
      768: {
         items: 2,
         dots: true,
      },
      992: {
         items: 2,
         dots: false,
         nav: true
      },
      1000: {
         items: 2,
         dots: false,
         nav: true
      }
   };

   const blogCnt = 6;

   // Dynamic Blog Data Loop
   const DataList = (() => {

      let blogPosts = []

      for (let i = 1; i <= blogCnt; i++) {

         blogPosts.push(
            <div className="blog-item" key={i + updater}>
               <div className="blog-block">
                  <div className="blog-box">
                     <div className="overflow-hidden">
                        <Link to={{
                           pathname: 'blog-details',
                           state: {
                              blogId: i
                           }
                        }}>
                           {/* <LazyLoad height={300}> */}
                           <img className="owl-lazy" data-src={t(`blog image ${i}`)} alt={t(`alt ${i}`)} />
                           {/* </LazyLoad> */}
                        </Link>
                     </div>
                  </div>
               </div>
               <div className="blog-text text-center text-md-left">
                  <Link to={{
                     pathname: 'blog-details',
                     state: {
                        blogId: i
                     }
                  }}>
                     <h3>{t(`blog title ${i}`)}</h3>
                     
                  </Link>
                  {t(`blog text ${i}`)}
               </div>
            </div>
         )
      }

      /* blogId++;

      blogPosts.push(
         <div className="blog-item" key={blogId + updater}>
            <div className="blog-block">
               <div className="blog-box">
                  <div className="overflow-hidden">
                     <Link to={{
                        pathname: 'blog-details',
                        state: {
                           blogId: 1
                        }
                     }}>
                        <img src={t(`blog image 1`)} alt={t(`alt 1`)} />
                     </Link>
                  </div>
               </div>
            </div>
            <div className="blog-text text-center text-md-left">
               <Link to={{
                  pathname: 'blog-details',
                  state: {
                     blogId: 1
                  }
               }}>
                  <h3>{t(`blog title 1`)}</h3>
               </Link>
            </div>
         </div>
      ) */

      return blogPosts;

   })()

   return (
      <section id="blog" className="blog">
         <div className="about-decor">
            <div className="about-circle1 circle-shadow">
               <SvgCircle color1="#F2E541" color2="#F2E541" r1="40" r2="10" />
            </div>
            <div className="about-circle2 circle-shadow">
               <SvgCircle color1="#F2E541" color2="#F2E541" r1="50" r2="30" />
            </div>
         </div>
         <div className="container">
            <div className="row">
               <div className="col-sm-12">
                  <h2 className="title pink-title text-center text-md-left"><span>{t('ourminds')}</span> {t('applications')}</h2>
               </div>
               <div className="col-sm-12">
                  <OwlCarousel
                     className="blog-carousel owl-carousel owl-theme"
                     lazyLoad={true}
                     loop={true}
                     margin={30}
                     nav={false}
                     dots={true}
                     responsive={options}
                     navClass={['owl-prev', 'owl-next']}
                     navText={['<img src="assets/images/back.png" alt="back">', '<img src="assets/images/next.png" alt="next">']}
                     key="1"
                  >
                     {DataList}
                  </OwlCarousel>
               </div>
            </div>
         </div>
      </section>
   );
}

export default Blog;


// WEBPACK FOOTER //
// ./src/components/blog.js